var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',{staticClass:"row text-center"},[_c('f7-col',[_c('f7-preloader',{attrs:{"color":_vm.color}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }